import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

// 设置全局网页标题
document.title = '北京灵眸云图科技有限公司 - 精彩直播，尽在灵眸云图'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.mount('#app')
